import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";
import axios from "axios";

interface Request {
  url: string;
  data: Record<string, any>;
}

const requestFun = async ({ url, data }: Request): Promise<any> => {
  const response = await axios.put(url, data, {
    headers: {
      "Content-Type": data.type || "application/octet-stream",
    },
  });
  return response.status;
};

export const useS3Upload = () => {
  return useMutation<void, Error, Request>({
    mutationFn: requestFun,
  });
};
